var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServerError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 219,
    viewBox: "0 0 350 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2814_1128)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2814_1128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 350,
    height: 219
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350 0H0V218.412H350V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2814_1128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4722 133.109C128.247 133.109 158.059 103.312 158.059 66.5547C158.059 29.7976 128.247 0 91.4722 0C54.6982 0 24.8867 29.7976 24.8867 66.5547C24.8867 103.312 54.6982 133.109 91.4722 133.109Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9795C0 40.1947 15.1985 59.7895 33.9808 59.7895L0 15.9795Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.981 59.7905C33.981 35.3032 50.9416 15.4883 71.9016 15.4883L33.981 59.7905Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.312 18.1748C12.312 41.1767 22.0037 59.7896 33.981 59.7896L12.312 18.1748Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.981 59.79C33.981 28.5006 53.5848 3.18164 77.8115 3.18164L33.981 59.79Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.832 60.0988C26.832 60.0988 31.6511 59.9505 33.1034 58.9169C34.5558 57.8831 40.5163 56.6488 40.8766 58.3066C41.2369 59.9645 48.1187 66.552 42.6781 66.5959C37.2374 66.6398 30.0364 65.7488 28.5869 64.8663C27.1373 63.9837 26.832 60.0988 26.832 60.0988Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M42.7752 66.0189C37.3345 66.0627 30.1335 65.1719 28.6839 64.2893C27.58 63.6172 27.1401 61.2054 26.993 60.0928C26.891 60.0971 26.832 60.099 26.832 60.099C26.832 60.099 27.1373 63.9838 28.5869 64.8664C30.0364 65.7489 37.2374 66.6399 42.6781 66.596C44.2486 66.5834 44.7911 66.0248 44.7613 65.1977C44.5431 65.6974 43.9441 66.0095 42.7752 66.0189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0868 140.59C94.3722 140.59 120.544 137.031 120.544 132.641C120.544 128.251 94.3722 124.691 62.0868 124.691C29.8014 124.691 3.62891 128.251 3.62891 132.641C3.62891 137.031 29.8014 140.59 62.0868 140.59Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.087 139.314C89.1925 139.314 111.166 136.326 111.166 132.64C111.166 128.955 89.1925 125.967 62.087 125.967C34.981 125.967 13.0073 128.955 13.0073 132.64C13.0073 136.326 34.981 139.314 62.087 139.314Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.532 218.411C310.391 218.411 350 213.025 350 206.382C350 199.738 310.391 194.352 261.532 194.352C212.672 194.352 173.063 199.738 173.063 206.382C173.063 213.025 212.672 218.411 261.532 218.411Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0991 208.921C126.449 208.921 150.242 205.686 150.242 201.695C150.242 197.704 126.449 194.468 97.0991 194.468C67.7488 194.468 43.9556 197.704 43.9556 201.695C43.9556 205.686 67.7488 208.921 97.0991 208.921Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.616 195.602C172.751 202.789 226.832 186.228 232.772 167.48",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7866 80.9283C96.7866 80.9283 137.426 69.6793 139.927 105.925C142.427 142.171 106.478 152.482 134.612 159.669",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5234 167.882C57.5234 167.882 69.7378 164.501 70.4895 175.395C71.2411 186.289 60.4361 189.387 68.8921 191.548",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.429 175.992L240.967 191.708C240.967 191.708 228.844 198.145 237.368 198.335C245.893 198.524 286.052 198.335 286.052 198.335C286.052 198.335 293.819 198.335 281.506 191.518L279.042 175.046L243.429 175.992Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M235.653 198.164C237.589 196.442 240.967 194.648 240.967 194.648L243.43 178.933L279.043 178.966L281.506 194.459C284.376 196.048 286.155 197.267 287.196 198.201C288.778 197.841 290.506 196.501 281.506 191.518L279.043 175.046L243.43 175.992L240.967 191.708C240.967 191.708 230.78 197.118 235.653 198.164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.63 66.457H186.464C183.349 66.457 180.823 68.9815 180.823 72.0956V172.531C180.823 175.644 183.349 178.169 186.464 178.169H335.63C338.746 178.169 341.271 175.644 341.271 172.531V72.0956C341.271 68.9815 338.746 66.457 335.63 66.457Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.873 72.4219H186.223V156.111H335.873V72.4219Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.047 70.7177C261.571 70.7177 261.994 70.2938 261.994 69.7709C261.994 69.248 261.571 68.8242 261.047 68.8242C260.524 68.8242 260.101 69.248 260.101 69.7709C260.101 70.2938 260.524 70.7177 261.047 70.7177Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.271 162.738V172.531C341.271 173.271 341.126 174.005 340.842 174.689C340.559 175.372 340.143 175.994 339.619 176.518C339.095 177.042 338.473 177.457 337.789 177.74C337.104 178.024 336.371 178.17 335.63 178.17H186.464C185.724 178.17 184.991 178.024 184.306 177.74C183.622 177.457 182.999 177.042 182.475 176.518C181.952 175.994 181.536 175.372 181.253 174.689C180.969 174.005 180.823 173.271 180.823 172.531V162.738H341.271Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.912 208.559V210.452H200.998V208.938L201.138 208.559L203.65 201.742H300.827L302.912 208.559Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.131 206.705C341.945 207.499 341.245 208.335 339.661 209.127C333.978 211.967 322.423 208.369 322.423 208.369C322.423 208.369 313.52 206.855 313.52 202.879C313.77 202.707 314.03 202.552 314.3 202.415C316.689 201.151 324.611 198.033 338.658 202.547C339.693 202.871 340.617 203.477 341.328 204.296C341.897 204.961 342.344 205.806 342.131 206.705Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M342.13 206.705C335.175 209.369 328.975 209.568 322.612 205.151C319.403 202.924 316.488 202.373 314.3 202.414C316.689 201.151 324.611 198.034 338.657 202.547C339.692 202.871 340.617 203.477 341.328 204.296C341.896 204.961 342.343 205.806 342.13 206.705Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.41 205.151C334.77 205.151 335.872 204.812 335.872 204.393C335.872 203.975 334.77 203.636 333.41 203.636C332.05 203.636 330.947 203.975 330.947 204.393C330.947 204.812 332.05 205.151 333.41 205.151Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.047 174.098C263.035 174.098 264.646 172.488 264.646 170.501C264.646 168.514 263.035 166.903 261.047 166.903C259.059 166.903 257.448 168.514 257.448 170.501C257.448 172.488 259.059 174.098 261.047 174.098Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M302.912 208.559V210.452H200.998V208.937L201.138 208.559H302.912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9745 49.6816H33.9521V125.298H98.9745V49.6816Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54 42.1826H27.3872V69.0545H105.54V42.1826Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54 74.0537H27.3872V100.926H105.54V74.0537Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.54 105.925H27.3872V132.797H105.54V105.925Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.9096 46.8701H84.9077V51.8695H89.9096V46.8701Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M97.0995 46.8701H92.0977V51.8695H97.0995V46.8701Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.289 46.8701H99.2871V51.8695H104.289V46.8701Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.9096 78.4287H84.9077V83.4283H89.9096V78.4287Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M97.0995 78.4287H92.0977V83.4283H97.0995V78.4287Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.289 78.4287H99.2871V83.4283H104.289V78.4287Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.9096 109.987H84.9077V114.987H89.9096V109.987Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M97.0995 109.987H92.0977V114.987H97.0995V109.987Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.289 109.987H99.2871V114.987H104.289V109.987Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9752 192.789C112.614 192.789 123.671 181.738 123.671 168.105C123.671 154.472 112.614 143.42 98.9752 143.42C85.3353 143.42 74.2788 154.472 74.2788 168.105C74.2788 181.738 85.3353 192.789 98.9752 192.789Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2232 187.479H87.7207V200.914H95.2232V187.479Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.229 187.479H102.727V200.914H110.229V187.479Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9733 203.414C97.4258 203.414 100.225 202.365 100.225 201.07C100.225 199.776 97.4258 198.727 93.9733 198.727C90.5199 198.727 87.7207 199.776 87.7207 201.07C87.7207 202.365 90.5199 203.414 93.9733 203.414Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.978 203.102C112.432 203.102 115.231 202.053 115.231 200.759C115.231 199.464 112.432 198.415 108.978 198.415C105.526 198.415 102.727 199.464 102.727 200.759C102.727 202.053 105.526 203.102 108.978 203.102Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6001 170.292C104.261 170.292 108.041 166.515 108.041 161.856C108.041 157.197 104.261 153.42 99.6001 153.42C94.9389 153.42 91.1597 157.197 91.1597 161.856C91.1597 166.515 94.9389 170.292 99.6001 170.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5998 164.669C101.154 164.669 102.414 163.409 102.414 161.857C102.414 160.303 101.154 159.044 99.5998 159.044C98.0458 159.044 96.7866 160.303 96.7866 161.857C96.7866 163.409 98.0458 164.669 99.5998 164.669Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0189 145.15C73.0248 136.223 79.3995 127.203 89.2563 125.003C99.1138 122.803 108.721 128.256 110.715 137.182C112.709 146.109 106.177 149.401 96.3193 151.601C86.4617 153.801 77.013 154.076 75.0189 145.15Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.138 163.182C128.407 160.5 132.807 156.731 131.964 154.764C131.122 152.796 125.356 153.376 119.087 156.057C112.818 158.74 108.418 162.509 109.26 164.476C110.102 166.443 115.868 165.864 122.138 163.182Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8713 179.742C82.1411 177.06 86.5402 173.291 85.6978 171.324C84.8555 169.356 79.0898 169.936 72.8207 172.618C66.5511 175.301 62.1516 179.07 62.994 181.037C63.8364 183.005 69.6017 182.425 75.8713 179.742Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.355 175.292C113.355 177.708 107.131 182.478 100.225 182.478C93.3192 182.478 86.7827 178.02 86.7827 175.604C86.7827 173.188 93.3192 173.729 100.225 173.729C107.131 173.729 113.355 172.876 113.355 175.292Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2814_1128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 219,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/server-error.710cb7d0.svg";
export { ForwardRef as ReactComponent };